export const tempList = [
  {
    publisher: "Closet Cooking",
    title: "Jalapeno Popper Grilled Cheese Sandwich",
    source_url:
      "http://www.closetcooking.com/2011/04/jalapeno-popper-grilled-cheese-sandwich.html",
    recipe_id: "35382",
    image_url:
      "http://static.food2fork.com/Jalapeno2BPopper2BGrilled2BCheese2BSandwich2B12B500fd186186.jpg"
  },
  {
    publisher: "The Pioneer Woman",
    title: "Perfect Iced Coffee",
    source_url:
      "http://thepioneerwoman.com/cooking/2011/06/perfect-iced-coffee/",
    recipe_id: "47024",
    image_url: "http://static.food2fork.com/icedcoffee5766.jpg"
  },
  {
    publisher: "The Pioneer Woman",
    title: "Crash Hot Potatoes",
    source_url:
      "http://thepioneerwoman.com/cooking/2008/06/crash-hot-potatoes/",
    recipe_id: "47319",
    image_url: "http://static.food2fork.com/CrashHotPotatoes5736.jpg"
  }
];
